// extracted by mini-css-extract-plugin
export default {"box":"Visited_box__cxdEE","textoverflow":"Visited_textoverflow__zD3XJ","align_middle":"Visited_align_middle__bz9-K","list_viewed":"Visited_list_viewed__tTZTO"};